const doc = [({"en":({"buttonBookingCamp":({"cancelBookingPlan":"Cancel this plan", "cancelBookingRoom":"Cancel this section"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;